export default __webpack_public_path__ + "static/media/link-icon.44b84c01.svg";